import React, { ReactElement } from 'react';
import './style.scss';
import { IconSize, SvgIcon } from '../svgIcon';
import { FormErrorScrollTarget } from '../formErrorScroll';

type QuestionCardProps = {
  topChildren?: React.ReactNode;
  bottomChildren?: React.ReactNode;
  error?: string;
};

export const QuestionCard = (props: QuestionCardProps) => {
  const { topChildren, bottomChildren, error } = props;
  return (
    <>
      <div className="questionCard">
        <FormErrorScrollTarget error={error} position='start'/>
        <div className="questionCard_top">{topChildren}</div>
        <div className="questionCard_bottom">{bottomChildren}</div>
      </div>
    </>
  );
};

export type CardLabelProps = {
  letter: React.ReactNode;
  sentence?: React.ReactNode;
  sentenceIcon?: string;
  help?: React.ReactNode;
};

export const CardLabel = (props: CardLabelProps) => {
  const { letter, sentence, sentenceIcon, help } = props;
  return (
    <>
      <div className="cardLabel">
        <div className="cardLabel_letter">{letter}</div>
        <div className="cardLabel_wrapper">
          <div className="cardLabel_wrapper_sentence">
            {sentenceIcon && <SvgIcon icon={sentenceIcon} size={IconSize.icon_xs} />}
            {sentence}
          </div>
          <div className="cardLabel_wrapper_help">{help}</div>
        </div>
      </div>
    </>
  );
};
